import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransferBlockedComponentComponent } from './transfer-blocked-component.component';


@NgModule({
    declarations: [TransferBlockedComponentComponent],
    imports: [CommonModule],
    exports: [TransferBlockedComponentComponent]
  
})
export class TransferBlockedModule { }